import type { ValueOf } from '../types';

export const META_STATUS_CODE = {
  NOT_FOUND_SERVICE: '404322', // 리전에 제공되지 않는 서비스
  NOT_FOUND_ROUTE: '404352', // 리전에 제공되지 않는 서비스의 하위 메뉴
} as const;

export type MetaStatusCode = ValueOf<typeof META_STATUS_CODE>;
